import * as React from 'react';
import { OverlayTrigger, Glyphicon, Tooltip, InputGroup, DropdownButton, MenuItem, Button, Panel, ButtonGroup } from 'react-bootstrap';

export default class AnalyticsChartHeader extends React.Component<any, any> {

    constructor(props:any) {
        super(props);

        this.state = {
            chartInfoExpanded: false,
        }
    }

    private handleOnToggle() {
        
    }

    private handleMenuSelect(eventKey: any, e: any) {
        // console.log("KEY:",eventKey);
        this.props.menuItemSelected(eventKey);
    }

    private handleChapterSelect(eventKey: any, e: any) {
        console.log("KEY:",eventKey, e.target.id);
        this.props.chapterItemSelected(eventKey, e.target.id);
    }

    render() {
        return (
            <div>
                <div className='header '>
                    <h2 className='pageHeader'>{this.props.title}</h2>
                    <div className='chartSettings'>
                        <ButtonGroup>
                            {
                                this.props.showChapterMenu ?
                                <DropdownButton
                                    className="chartButton"
                                    bsStyle="default"
                                    title={this.props.chapterSetting}
                                    key="btnKey2"
                                    id={`dropdown-basic-${1}`}
                                    >
                                    {this.props.analyticsData.map((c:any, i:number) => <MenuItem id={i.toString()} eventKey={c.name} key={c.name} title={c.name} onSelect={this.handleChapterSelect.bind(this)}>{c.name}</MenuItem>)}
                                </DropdownButton> : null
                            }
                            {
                                this.props.showPercentMenu ?
                                <DropdownButton
                                    className="chartButton"
                                    bsStyle="default"
                                    title={this.props.menuSetting}
                                    key="btnKey1"
                                    id={`dropdown-basic-${1}`}
                                    >
                                    <MenuItem eventKey="Percent" onSelect={this.handleMenuSelect.bind(this)}>Percent</MenuItem>
                                    <MenuItem eventKey="Total" onSelect={this.handleMenuSelect.bind(this)}>Total</MenuItem>
                                </DropdownButton> : null
                            }
                            <Button className='chartButton chartInfoToggleBtn' onClick={() => this.setState({ chartInfoExpanded: !this.state.chartInfoExpanded })}><Glyphicon glyph="info-sign" /></Button>
                        </ButtonGroup>
                    </div>
                </div>
                <Panel className="chartInfo" expanded={this.state.chartInfoExpanded} onToggle={this.handleOnToggle}>
                    <Panel.Collapse>
                        <Panel.Body className='chartInfoBody'>
                        {this.props.infoText}
                        </Panel.Body>
                    </Panel.Collapse>
                </Panel>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/analytics/AnalyticsChartHeader.tsx